<template>
  <footer class="footer__menu">
    <v-footer
        fixed
        padless
        width="100%"
        height="70px"
        class="amber lighten-4 footer__body"
    >
        <v-container
            class="footermenu__container amber lighten-4"
        >
                <v-row
                no-gutters
                justify="center"
                >
                    <v-btn height="70px" class="footermenu__body amber lighten-4 text-center" to="/">
                    <v-col>
                        <font-awesome-icon
                            class="fotter__menu__icon"
                            :icon="['fas', 'dove']">
                        </font-awesome-icon>
                        <v-card-text
                            class="footer__menu__text"
                        >
                            HOME
                        </v-card-text>
                    </v-col>
                    </v-btn>
                    <v-btn
                    height="70px"
                    class="footermenu__body amber lighten-4 text-center"
                        to="/all">
                    <v-col>
                        <font-awesome-icon
                            class="fotter__menu__icon"
                            :icon="['fas', 'dove']">
                        </font-awesome-icon>
                        <v-card-text
                            class="footer__menu__text"
                            to="/all"
                        >
                            みんなのついじぇね
                        </v-card-text>
                    </v-col>
                    </v-btn>
                    <v-btn
                    v-if="userinfo"
                    height="70px"
                    class="footermenu__body amber lighten-4 text-center"
                    v-bind:to="{name:'UserPage', params: {screen_name: userinfo.screenName}}"
                    >
                    <v-col>
                        <font-awesome-icon
                            class="fotter__menu__icon"
                            :icon="['fas', 'dove']">
                        </font-awesome-icon>
                        <v-card-text
                            class="footer__menu__text"
                        >
                            ユーザーページ
                        </v-card-text>
                    </v-col>
                    </v-btn>
            </v-row>
        </v-container>
    </v-footer>
    </footer>
</template>

<script>
export default {
    computed: {
    userinfo () {
      return this.$store.getters['auth/user']
    }
    }
}
</script>

<style>
    .footer__body{
        bottom:0;
        width: 100%;
     }
    .footermenu__container {
        padding: 0px;
        width: 100%;
    }
    .footermenu__body {
        height: 70px;
        padding:0px;
        width: 33%;
    }
    .fotter__menu__icon { 
    /* width: 40px;
    height: 40px; */
     }
    .footer__menu__text {
        font-size: 0.5rem;
        padding: 0px;
        font-weight: bold;
    }
    .footer__menu {
        /* height: 100px; */
    }
</style>



// WEBPACK FOOTER //
// src/components/FooterMenu.vue